<template>
    <div>
        <div class="check_page" style="" v-if="show">
            <div class="check_inner2">
                <div>
                    <div class="check_title_div">
                        <Icon type="md-warning" style="color:red;font-size:18px;margin-right:5px" />
                        检测到当前项目有数据不完整，请先完善缺失数据，再进行其他操作！
                    </div>
                    <div class="check_inner">
                        <div class="title_div">
                            <div class="title3_xiantian">
                                
                            </div>
                            <div class="title2">
                                <Icon type="ios-construct" />
                                数据类型
                            </div>
                            <div class="title2_1">
                                <div style="width: 55px;;">

                                </div>
                                <div>
                                    当前状态
                                </div>
                                <div class="refresh_status" @click="refresh_status">
                                    <Icon type="md-refresh" />点击刷新
                                </div>

                            </div>
                            <div class="title2">
                                <Icon type="md-reorder" />操作
                            </div>
                        </div>
                        <div class="title_div">
                             <div class="bitian">
                                *重要
                            </div>
                            <div class="title">
                                项目合作主体
                            </div>
                            <div class="title3">
                                <div v-if="status_dict.subject_status" class="success">
                                    <Icon type="md-checkmark-circle" />
                                    <span class="title_span">已完善({{ status_dict.subject_name }})</span>
                                </div>
                                <div v-else class="error">
                                    <Icon type="md-close-circle" />
                                    <span class="title_span">未完善</span>

                                </div>
                            </div>
                            <div class="title editor" @click="editor('project_subject')">
                                去补充
                                <Icon type="md-arrow-forward" />
                            </div>
                        </div>
                        <div class="title_div">
                            <div class="bitian">
                                *重要
                            </div>
                            <div class="title">
                                项目所属地区
                            </div>
                            <div class="title3">
                                <div v-if="status_dict.project_place_status == 1" class="success">
                                    <Icon type="md-checkmark-circle" />
                                    <span class="title_span">已完善({{ status_dict.project_place }})</span>
                                </div>
                                <div v-else class="error">
                                    <Icon type="md-close-circle" />
                                    <span class="title_span">未完善</span>

                                </div>
                            </div>
                            <div class="title editor" @click="editor('project_place')">
                                去补充
                                <Icon type="md-arrow-forward" />
                            </div>
                        </div>
                       
                        <div class="title_div">
                            <div class="bitian">
                                *重要
                            </div>
                            <div class="title">
                                项目提成占比
                            </div>
                            <div class="title3">
                                <div v-if="status_dict.project_data_user_count > 0" class="success">
                                    <Icon type="md-checkmark-circle" />
                                    <span class="title_span">{{ status_dict.project_data_user_count }}/{{
                                        status_dict.project_auth_user_count }}</span>

                                </div>
                                <div v-else class="error">
                                    <Icon type="md-close-circle" />
                                    <span class="title_span">未完善</span>
                                    <span class="title_span">{{ status_dict.project_data_user_count }}/{{
                                        status_dict.project_auth_user_count }}</span>
                                </div>
                            </div>
                            <div class="title editor" @click="editor('project_data_user')">
                                去补充
                                <Icon type="md-arrow-forward" />
                            </div>
                        </div>
                        <div class="title_div">
                            <div class="bitian">
                                *必填
                            </div>
                            <div class="title">
                                项目详细介绍
                            </div>
                            <div class="title3">
                                <div v-if="status_dict.percentage_of_perfection > 80" class="success">
                                    <Icon type="md-checkmark-circle" />
                                    <span class="title_span">已完善({{ status_dict.percentage_of_perfection }}%)</span>
                                </div>
                                <div v-else class="error">
                                    <Icon type="md-close-circle" />
                                    <span class="title_span">未达到80% ({{ status_dict.percentage_of_perfection }}%)</span>

                                </div>
                            </div>
                            <div class="title editor" @click="editor('percentage_of_perfection')">
                                去补充
                                <Icon type="md-arrow-forward" />
                            </div>
                        </div>
                        <div class="title_div">
                            <div class="bitian">
                                *必填
                            </div>
                            <div class="title">
                                项目业务合同
                            </div>
                            <div class="title3">
                                <div v-if="status_dict.business_contract_count > 0" class="success">
                                    <Icon type="md-checkmark-circle" />
                                    <span class="title_span">已完善({{ status_dict.business_contract_count }}份)</span>

                                </div>
                                <div v-else class="error">
                                    <Icon type="md-close-circle" />
                                    <span class="title_span">未完善</span>

                                </div>
                            </div>
                            <div class="title editor" @click="editor('project_contract')">
                                去补充
                                <Icon type="md-arrow-forward" />
                            </div>
                        </div>
                        <div class="title_div">
                            <div class="bitian">
                                *必填
                            </div>
                            <div class="title">
                                岗位结算信息
                            </div>
                            <div class="title3">
                                <div v-if="status_dict.job_count > 0" class="success">
                                    <Icon type="md-checkmark-circle" />
                                    <span class="title_span">已完善({{ status_dict.job_count }}个)</span>

                                </div>
                                <div v-else class="error">
                                    <Icon type="md-close-circle" />
                                    <span class="title_span">未完善</span>

                                </div>
                            </div>
                            <div class="title editor" @click="editor('project_job')">
                                去补充
                                <Icon type="md-arrow-forward" />
                            </div>
                        </div>
                        <div class="title_div">
                            <div class="bitian">
                                *必填
                            </div>
                            <div class="title">
                                本周需求更新
                            </div>
                            <div class="title3">
                                <div v-if="status_dict.week_need_status" class="success">
                                    <Icon type="md-checkmark-circle" />
                                    <span class="title_span">已更新({{ status_dict.week_need_count }}人)</span>

                                </div>
                                <div v-else class="error">
                                    <Icon type="md-close-circle" />
                                    <span class="title_span">未更新</span>

                                </div>
                            </div>
                            <div class="title editor" @click="editor('week_need_status')">
                                去补充
                                <Icon type="md-arrow-forward" />
                            </div>
                        </div>
                        <div class="title_div">
                            <div class="bitian">
                                *必填
                            </div>
                            <div class="title">
                                项目员工宿舍
                            </div>
                            <div class="title3">
                                <div v-if="status_dict.dormitory_status > 0" class="success">
                                    <Icon type="md-checkmark-circle" />
                                    <span class="title_span">{{ status_dict.dormitory_status_fmt }}({{
                                        status_dict.dormitory_count }}间)</span>

                                </div>
                                <div v-else class="error">
                                    <Icon type="md-close-circle" />
                                    <span class="title_span">未完善</span>

                                </div>
                            </div>
                            <div class="title editor" @click="editor('dormitory')">
                                去补充
                                <Icon type="md-arrow-forward" />
                            </div>
                        </div>
                        <div class="title_div">
                            <div class="bitian">
                                *必填
                            </div>
                            <div class="title">
                                项目市占率
                            </div>
                            <div class="title3">
                                <div v-if="status_dict.market_share_count > 0" class="success">
                                    <Icon type="md-checkmark-circle" />
                                    <span class="title_span">{{ status_dict.market_share_count }}家(占{{
                                        status_dict.market_share }}%)</span>

                                </div>
                                <div v-else class="error">
                                    <Icon type="md-close-circle" />
                                    <span class="title_span">未完善</span>

                                </div>
                            </div>
                            <div class="title editor" @click="editor('market_share')">
                                去补充
                                <Icon type="md-arrow-forward" />
                            </div>
                        </div>
                        
                        <!-- <div class="title_div">
                            <div class="title">
                                项目发薪表模板
                            </div>
                            <div class="title3">
                                <div v-if="status_dict.faxin_template_count > 0" class="success">
                                    <Icon type="md-checkmark-circle" />
                                    <span class="title_span">已上传({{ status_dict.faxin_template_count }})</span>

                                </div>
                                <div v-else class="error">
                                    <Icon type="md-close-circle" />
                                    <span class="title_span">未上传</span>
                                </div>
                            </div>
                            <div class="title editor" @click="editor('faxin_template_count')">
                                去补充
                                <Icon type="md-arrow-forward" />
                            </div>
                        </div> -->

                        <div class="title_div">
                            <div class="bitian2">
                                选填
                            </div>
                            <div class="title">
                                项目入职告知书
                            </div>
                            <div class="title3">
                                <div v-if="status_dict.gaozhishu_count > 0" class="success">
                                    <Icon type="md-checkmark-circle" />
                                    <span class="title_span">已上传({{ status_dict.gaozhishu_count }})</span>

                                </div>
                                <div v-else class="error">
                                    <Icon type="md-close-circle" />
                                    <span class="title_span">未上传</span>
                                </div>
                            </div>
                            <div class="title editor" @click="editor('gaozhishu_count')">
                                去补充
                                <Icon type="md-arrow-forward" />
                            </div>
                        </div>

                         <div class="title_div">
                            <div class="bitian2">
                                *选填 
                            </div>
                            <div class="title">
                                项目坐标
                            </div>
                            <div class="title3">
                                <div v-if="status_dict.project_location_count >0" class="success">
                                    <Icon type="md-checkmark-circle" />
                                    <span class="title_span">已完善({{ status_dict.project_location_count }}个区域)</span>
                                </div>
                                <div v-else class="error">
                                    <Icon type="md-close-circle" />
                                    <span class="title_span">未完善</span>

                                </div>
                            </div>
                            <div class="title editor" @click="editor('project_location')">
                                去补充
                                <Icon type="md-arrow-forward" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="skip">
                <span class="skip_span" @click="click_pass">本次暂时跳过(还剩{{ status_dict.pass_count }}次)
                    <Icon type="md-arrow-round-forward" />
                </span>
            </div>
            <div class="project_id">
                {{ project_id }}
            </div>
        </div>
        
        <Modal v-model="pass_show" title="暂时跳过项目完善" ok-text="现在就去完善" cancel-text="我很忙,下次再说吧" :closable="false"
            @on-ok="pass_show = false" @on-cancel="click_pass_confirm">
            <div style="line-height: 30px;">
                下次一定要来完善哦🥰，中国人不骗中国人🤗，这个项目还能再跳过<span style="font-weight: 600;color:red;font-size: 16px;">{{
                    status_dict.pass_count }}次</span>，没次数将无法跳过!😐😶
            </div>
        </Modal>
    </div>
</template>

<script>
import { http, open_new_page } from "@/utils/http.js";

export default {

    name: "check",
    data() {

        return {
            show: false,
            project_id: '',
            status_dict: {},
            pass_show: false,
            pass_title: ''

        }
    },
    mounted() {
    },
    methods: {
        click_pass() {
            this.pass_show = true
        },

        click_pass_confirm() {
            this.$Message.warning('未完善跳过次数 -1')
            var that = this;
            var obj = {
                project_id: this.project_id,
                status_dict:this.status_dict
            };
            http(
                "post",
                process.env.VUE_APP_HOST + "/my_project/detail/wanshan_pass",
                obj,
                true
            )
                .then((res) => {
                    if (res.code == 0) {
                        console.log(res)
                        that.show = false
                        that.$Message.success({
                            content: res.msg,
                            duration: 6,
                        });
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 6,
                        });
                    }
                })
                .catch((res) => {
                    console.log(res, "请求出错");
                });
        },

        refresh_status() {
            this.$Message.success('重新检测运行完成，请完善缺失数据')
            this.get_perfect_check();
        },
        editor(status) {

            if (status == 'week_need_status') {
                this.$emit('change', 'week_need_status')
            }

            if (status == 'project_job') {
                this.$emit('change', 'project_job')
            }
            if (status == 'project_contract') {
                this.$emit('change', 'project_contract')
            }
            if (status == 'percentage_of_perfection') {
                this.$emit('change', 'percentage_of_perfection')
            }
            if (status == 'project_subject') {
                this.$emit('change', 'project_subject')
            }
            if (status == 'project_place') {
                this.$emit('change', 'project_place')
            }
            if (status == 'dormitory') {
                this.$emit('change', 'dormitory')
            }
            if (status == 'market_share') {
                this.$emit('change', 'market_share')
            }
            if (status == 'project_data_user') {
                this.$emit('change', 'project_data_user')
            }
            if(status == 'gaozhishu_count'){
                this.$emit('change','gaozhishu_count')
            }
            if(status == 'project_location'){
                this.$emit('change','project_location')
            }



        },

        open(project_id) {
            this.project_id = project_id
            this.get_perfect_check();
        },
        get_perfect_check() {
            var that = this;
            var obj = {
                project_id: this.project_id,
            };
            http(
                "post",
                process.env.VUE_APP_HOST + "/my_project/detail/perfect_check",
                obj,
                true
            )
                .then((res) => {
                    if (res.code == 0) {
                        console.log('检查', res)
                        that.status_dict = res.data
                        if (res.data.business_contract_count == 0 ||
                            res.data.project_place_status == 0 ||
                            res.data.job_count == 0 ||
                            res.data.percentage_of_perfection < 80 ||
                            res.data.subject_status == false ||
                            res.data.week_need_status == false
                            || res.data.dormitory_status == 0 ||
                            res.data.market_share_count == 0 ||
                            res.data.project_data_user_count == 0 
                            // res.data.project_location_count == 0
                            // ||res.data.faxin_template_count == 0 ||
                            // res.data.gaozhishu_count == 0
                        ) {
                            console.log('未完善')
                            that.show = true
                        } else {
                            that.show = false
                        }
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                })
                .catch((res) => {
                    console.log(res, "请求出错");
                });
        },
    }
}
</script>

<style scoped>
.bitian{
    width: 80px;
    text-align: center;
    height: 40px;
    font-size: 13px;
    line-height: 40px;
    color: #ff2525;
    border: 1px solid #ededed;
    /* background-color: red; */

}
.bitian2{
    width: 80px;
    text-align: center;
    height: 40px;
    font-size: 13px;
    line-height: 40px;
    color: #ccc;
    border: 1px solid #ededed;
    /* background-color: red; */

}

.project_id {
    margin-top: 10px;
    color: #f9f9f9;
    font-weight: 300;
    font-size: 12px;
    text-align: center;
}

.skip {
    padding-top: 50px;
    text-align: center;
    font-size: 13px;
}

.skip_span {
    color: #ccc
}

.skip_span:hover {
    cursor: pointer;
    color: #0044c2
}

.check_inner2 {
    display: flex;
    justify-content: center;
}

.refresh_status {
    font-size: 12px;
    cursor: pointer;
    right: 5px;
    padding: 0 5px;
    height: 18px;
    border-radius: 3px;
    background-color: rgb(255, 231, 136);
    float: right;
    display: flex;
    align-items: center;
    color: #585858;
    margin-right: 10px;
}

.refresh_status:hover {
    font-weight: 600;
}

.editor:hover {
    color: #0466dd;
    font-weight: 600;
    cursor: pointer;
}

.check_title_div {

    margin-top: 60px;
    margin-bottom: 15px;
    font-weight: 600;
    color: #333;
    text-align: center;
}

.check_inner {}

.title_div {
    display: flex;
    align-items: center;
}

.title_span {
    font-size: 13px;
}

.title {
    width: 150px;
    text-align: center;
    height: 40px;
    font-size: 13px;
    line-height: 40px;
    color: #666;
    border: 1px solid #ededed;
    /* background-color: red; */
}


.title3_xiantian {
    width: 80px;
    text-align: center;
    height: 40px;
    font-size: 13px;
    line-height: 40px;
    color: #666;
    
    background-color: #0466dd;
    border: 1px solid #ededed;
    /* background-color: red; */
}

.title3 {
    width: 200px;
    color: #fff;
    text-align: center;
    height: 40px;
    font-size: 14px;
    line-height: 40px;
    border: 1px solid #ededed;
    /* background-color: red; */
}

.title2 {
    background-color: #0466dd;
    width: 150px;
    color: #fff;
    text-align: center;
    height: 40px;
    font-size: 14px;
    line-height: 40px;
    border: 1px solid #ededed;
    /* background-color: red; */
}

.title2_1 {
    background-color: #0466dd;
    width: 200px;
    position: relative;
    color: #fff;
    text-align: center;
    height: 40px;
    font-size: 14px;
    line-height: 40px;
    border: 1px solid #ededed;
    display: flex;
    justify-content: space-between;
    align-items: center;
    /* background-color: red; */
}

.success {
    color: #0466dd;
    font-size: 16px;
}

.error {
    color: red;
    font-size: 16px;

}

.check_page {
    position: absolute;
    top: 40px;
    left: 0px;
    z-index: 10;
    background-color: rgb(255, 255, 255);
    width: 100%;
    height: calc(100% - 40px)
}
</style>